module.exports = __webpack_public_path__ + "img/itx-file-type-webm.35c687d9.svg";